import React, { lazy, memo } from 'react'
import SuspenseWithCatch from '../ui/SuspenseWithCatch'
import SomethingWentWrong from '../ui/SomethingWentWrong'

import Loading from '../ui/Loading'
import { Bundles, loadBundle } from '../../util/moduleLoader'

const AuthRegisterAsync = lazy(() => loadBundle(Bundles.Auth).then((bundle) => ({ default: bundle.AuthRegister })))

const AuthRegister = () => {
  return (
    <SuspenseWithCatch fallback={<SomethingWentWrong />} loading={<Loading />}>
      <AuthRegisterAsync />
    </SuspenseWithCatch>
  )
}

export default memo(AuthRegister)
